import clip from "text-clipper";

export default function (value, length, ending = '...') {
    if (!value) {
        return '?';
    }

    if (length < 0) {
        return value;
    }

    return clip(value, length, { html: value.startsWith('<p'), indicator: ending })
}